import React, { Component } from "react";
import {Form }  from 'react-bootstrap'
import {fetchToken} from '../../Util.js';
import { reactAI } from "react-appinsights";
import uuid from 'react-native-uuid';
import {appInsights} from '../../common/AppInsights/AppInsights';
import {SERVICE_NAME,SERVICE_OFFERING,COMPONENT_NAME,SERVICE_LINE,COMPONENT_ID} from "../../common/Constants/Constants";

export class ReactEditCategoryDropDown extends Component{

    constructor(props)
    {
       
        super(props)        
        this.state={categorydata:[],selectedCategory:null,readOnly:true,default:null}
      
    }

    async componentDidMount() {


        appInsights.trackTrace({ message: 'EditCategory Component Loaded.' },
                     {
                         "userName": this.props.email,
                         "ComponentId" : COMPONENT_ID,
                         "ComponentName" : COMPONENT_NAME,
                         "EnvironmentName" : window.env.ENVIRONMENT,
                         "ServiceLineName" : SERVICE_LINE,
                         "ServiceName" : SERVICE_NAME,
                         "ServiceOfferingName" : SERVICE_OFFERING,
                         "Correlation Id": uuid.v1(),
                         "Component": 'Category Page',
                     });
        var token = await fetchToken();
        var bearer = 'Bearer ' + token;
        var correlationId = uuid.v1();
        var apimUrl = window.env.APIMURL + "/api/outage/getcategorymappings"; 
        fetch(apimUrl,{
            method: 'GET',
            headers: {
                'authorization': bearer,
                'Accept' : 'application/json',
                'CorrelationId': correlationId,
                'Content-Type': 'application/json'
            }})
          .then(response => {
            return response.json();
          })        
          .then(data => {   
                   
              this.setState({ categorydata:data
              });
            })
            .catch(error => {
                var err = 
                {
                 "message": "Exception occured in EditCategory page while getting the Category Mappings from the DB",
                 "ComponentId" : COMPONENT_ID,
                 "ComponentName" : COMPONENT_NAME,
                 "EnvironmentName" : window.env.ENVIRONMENT,
                 "ServiceLineName" : SERVICE_LINE,
                 "ServiceName" : SERVICE_NAME,
                 "ServiceOfferingName" : SERVICE_OFFERING,
                 "Component": 'EditCategory Page',
                 "userName": this.props.email,
                 "exception": error.message,
                 "Correlation Id": correlationId
                }
             appInsights.trackException({exception: error,properties : err});
            })
        
    }

        render(){       
        return(          
            <div>
            <label htmlFor="outageTitle">Category</label>
           
            <Form.Control id="category" title="Select Group" as="select" disabled={this.props.readOnly} value = {this.state.selectedCategory == null | "" ? this.props.event.category :this.state.selectedCategory}  onChange={(event)=>{ this.setState({ selectedCategory:event.target.value})}}>                   
                <option value={null}>--Select Category--</option> 
                {                    
                    [...new Set(this.state.categorydata.map((x)=>x.category))].map((todo, index) => <option value={todo} as="select" >{todo}</option> )
                }
            </Form.Control> 
                   

        </div>  
        )      
    }
}
export default ReactEditCategoryDropDown;